import { Routes } from '@angular/router';
import { provideState } from '@ngrx/store';
import { StateCourseEffects } from './data-access/+state/course.effects';
import { provideEffects } from '@ngrx/effects';

import * as fromStateCourse from './data-access/+state/course.reducer';

import { CourseDetailsComponent } from './pages/course-details/course-details.component';
import { ClearingCourseDetailsComponent } from './pages/clearing-course-details/clearing-course-details.component';

export const COURSE_ROUTES: Routes = [
	{
		path: '',
		providers: [
			provideState(
				fromStateCourse._STATE_COURSE_FEATURE_KEY,
				fromStateCourse.reducer,
			),
			provideEffects([StateCourseEffects]),
		],
		children: [
			{
				path: 'clearing/:courseSlug',
				component: ClearingCourseDetailsComponent,
			},
			{
				path: ':studyLevel/:courseSlug',
				component: CourseDetailsComponent,
			},
		],
	},
];
